__webpack_require__.p = "https://parth-5097.github.io/parthiv-portfolio/";